export default "__VITE_ASSET__CxBeMeqa__"